var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 172,
    viewBox: "0 0 288 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3558_21202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-37.312 159.28H41.7881M292.75 159.28H260.607M68.2862 159.28H137.782M164.565 159.28H234.208",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.312 124.897H27.9957",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.638 74.3582C146.506 73.7942 146.436 73.206 146.436 72.6014C146.436 68.3812 149.857 64.96 154.077 64.96C158.297 64.96 161.719 68.3812 161.719 72.6014C161.719 73.2223 161.645 73.8259 161.505 74.4038",
    stroke: "#021317"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.077,
    cy: 72.9623,
    r: 1.14442,
    stroke: "#021317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.039 65.4113V72.2417",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.887 147.046C133.021 143.309 129.075 128.687 127.604 114.218M171.95 147.046C192.854 147.046 219.378 147.046 237.509 147.046M153.646 27.4872C153.778 27.29 153.907 27.0977 154.034 26.9104C154.401 26.3669 155.017 26.0458 155.673 26.0458L238.676 26.0458C240.885 26.0458 242.676 27.8367 242.676 30.0458V39.7245M152.476 29.2739C145.117 40.7073 132.314 64.0814 128.28 84.2821M127.928 86.166C127.856 86.5829 127.787 86.9981 127.723 87.4117C127.275 90.2924 126.99 94.0807 126.921 98.3594",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.277,
    y: 23.0651,
    width: 74.1986,
    height: 2.98072,
    rx: 1.49036,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.271 29.2706H151.995C151.505 29.2706 151.107 28.8729 151.107 28.3824V28.3824C151.107 27.892 151.505 27.4943 151.995 27.4943H213.271C215.276 27.4943 216.562 29.6255 215.628 31.3997L187.59 84.6654C187.13 85.5407 186.222 86.0887 185.233 86.0887H127.793C127.302 86.0887 126.905 85.6911 126.905 85.2006V85.2006C126.905 84.7101 127.302 84.3124 127.793 84.3124H185.233C185.562 84.3124 185.865 84.1298 186.019 83.838L214.056 30.5724C214.368 29.981 213.939 29.2706 213.271 29.2706Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.255 84.3969L133.841 80.1366C134.204 79.5393 134.852 79.1745 135.551 79.1745H188.415",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.331 79.1745L141.844 75.3813C142.215 74.8222 142.841 74.486 143.511 74.486H190.856",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.24,
    y: 98.3742,
    width: 15.7568,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.24,
    y: 98.3742,
    width: 12.9483,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.119,
    cy: 106.253,
    rx: 3.03412,
    ry: 5.80931,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.102,
    y: 104.259,
    width: 12.3125,
    height: 3.98758,
    rx: 1.99379,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.521 120.047C154.072 116.495 151.194 131.01 151.5 137.082C154.087 133.901 158.511 134.006 163.662 139.047C169.188 144.456 176.827 147.001 184.966 147.001C172.638 138.615 176.229 123.369 165.521 120.047Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.485 137.173H137.189C138.089 133.24 138.893 124.487 145.786 119.478C150.73 119.478 158.264 119.478 161.413 119.478",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.431 144.77C161.095 144.608 160.738 144.52 160.369 144.52C158.351 144.52 156.715 147.127 156.715 150.343C156.715 153.559 158.351 156.166 160.369 156.166C162.387 156.166 164.022 153.559 164.022 150.343C164.022 149.82 163.901 148.934 163.82 148.452",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.636 141.545C167.915 143.859 168.754 147.101 168.754 150.343C168.754 157.724 164.77 163.708 159.855 163.708C154.94 163.708 150.955 157.724 150.955 150.343C150.955 142.962 154.94 136.979 159.855 136.979C160.394 136.979 160.921 137.051 161.434 137.188",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.283 137.253C149.082 140.431 147.72 144.826 147.72 149.681C147.72 159.38 153.153 167.242 159.855 167.242C166.556 167.242 171.989 159.38 171.989 149.681C171.989 147.905 171.807 146.191 171.468 144.575",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.525 166.573C155.439 167.035 154.44 167.242 153.25 167.242C146.548 167.242 141.115 159.38 141.115 149.682C141.115 144.692 142.553 140.189 144.862 136.992",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.894 139.198L158.858 149.96C158.423 150.89 158.783 151.999 159.681 152.497V152.497C160.671 153.044 161.916 152.64 162.396 151.617L167.013 141.767",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.052 98.4253C191.472 93.4813 192.265 89.3908 192.976 86.6806C194.973 79.0763 211.99 43.5574 219.649 28.8774C219.992 28.2196 220.668 27.8199 221.41 27.8199H238.899C240.003 27.8199 240.899 28.7154 240.899 29.8199V43.0512M191.217 114.059C192.302 123.893 195.473 134.674 202.653 144.173C203.023 144.663 203.604 144.944 204.218 144.944C212.905 144.944 225.792 144.944 234.264 144.944",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.536,
    y: 98.3742,
    width: 15.7568,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.536,
    y: 98.3742,
    width: 12.9483,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.415,
    cy: 106.253,
    rx: 3.03412,
    ry: 5.80931,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.398 74.3582C50.2653 73.7942 50.1951 73.206 50.1951 72.6014C50.1951 68.3812 53.6163 64.96 57.8366 64.96C62.0569 64.96 65.4781 68.3812 65.4781 72.6014C65.4781 73.2223 65.404 73.8259 65.2643 74.4038",
    stroke: "#021317"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.8366,
    cy: 72.9623,
    r: 1.14442,
    stroke: "#021317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7987 65.4113V72.2417",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.647 147.046C36.7807 143.309 32.8347 128.687 31.3638 114.218M75.7096 147.046C96.6132 147.046 123.138 147.046 141.269 147.046M57.4059 27.4872C57.5375 27.29 57.6666 27.0977 57.7933 26.9104C58.1608 26.3669 58.7763 26.0458 59.4324 26.0458L142.436 26.0458C144.645 26.0458 146.436 27.8367 146.436 30.0458V39.7245M56.236 29.2739C48.8762 40.7073 36.0733 64.0814 32.0396 84.2821M31.6876 86.166C31.6152 86.5829 31.5468 86.9981 31.4826 87.4117C31.0349 90.2924 30.7494 94.0807 30.6805 98.3594",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.037,
    y: 23.0651,
    width: 74.1986,
    height: 2.98072,
    rx: 1.49036,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.03 29.2706H55.7547C55.2642 29.2706 54.8665 28.8729 54.8665 28.3824V28.3824C54.8665 27.892 55.2642 27.4943 55.7547 27.4943H117.03C119.035 27.4943 120.322 29.6255 119.388 31.3997L91.3498 84.6654C90.8891 85.5407 89.9813 86.0887 88.9921 86.0887H31.5525C31.062 86.0887 30.6644 85.6911 30.6644 85.2006V85.2006C30.6644 84.7101 31.062 84.3124 31.5525 84.3124H88.9921C89.3219 84.3124 89.6245 84.1298 89.778 83.838L117.816 30.5724C118.127 29.981 117.698 29.2706 117.03 29.2706Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0146 84.3969L37.6008 80.1366C37.9635 79.5393 38.6117 79.1745 39.3105 79.1745H92.1741",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0901 79.1745L45.6037 75.3813C45.9742 74.8222 46.6002 74.486 47.2709 74.486H94.6154",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 98.3742,
    width: 15.7568,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 98.3742,
    width: 12.9483,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8784,
    cy: 106.253,
    rx: 3.03412,
    ry: 5.80931,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8618,
    y: 104.259,
    width: 12.3125,
    height: 3.98758,
    rx: 1.99379,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2805 120.047C57.8312 116.495 54.954 131.01 55.2597 137.082C57.8467 133.901 62.2709 134.006 67.4215 139.047C72.9478 144.456 80.3094 146.953 88.4479 146.953C76.1205 138.567 79.9885 123.369 69.2805 120.047Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2442 137.173H40.9484C41.8481 133.24 42.6523 124.487 49.5458 119.478C54.4892 119.478 62.0233 119.478 65.1725 119.478",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1902 144.77C64.8542 144.608 64.4976 144.52 64.1283 144.52C62.1105 144.52 60.4748 147.127 60.4748 150.343C60.4748 153.559 62.1105 156.166 64.1283 156.166C66.1461 156.166 67.7819 153.559 67.7819 150.343C67.7819 149.82 67.6607 148.934 67.5795 148.452",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.396 141.545C71.6749 143.859 72.5138 147.101 72.5138 150.343C72.5138 157.724 68.5293 163.708 63.6142 163.708C58.699 163.708 54.7145 157.724 54.7145 150.343C54.7145 142.962 58.699 136.979 63.6142 136.979C64.1531 136.979 64.6807 137.051 65.1932 137.188",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0422 137.253C52.8415 140.431 51.4799 144.826 51.4799 149.681C51.4799 159.38 56.9126 167.242 63.6142 167.242C70.3158 167.242 75.7485 159.38 75.7485 149.681C75.7485 147.905 75.5663 146.191 75.2275 144.575",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2851 166.573C59.1984 167.035 58.1992 167.242 57.0092 167.242C50.3076 167.242 44.8749 159.38 44.8749 149.682C44.8749 144.692 46.3127 140.189 48.6215 136.992",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.654 139.198L62.6179 149.96C62.1824 150.89 62.5422 151.999 63.441 152.497V152.497C64.4301 153.044 65.6759 152.64 66.1558 151.617L70.7729 141.767",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8111 98.4253C95.2314 93.4813 96.0245 89.3908 96.7359 86.6806C98.732 79.0763 115.749 43.5574 123.409 28.8774C123.752 28.2196 124.428 27.8199 125.17 27.8199H142.658C143.763 27.8199 144.658 28.7154 144.658 29.8199V43.0512M94.9769 114.059C96.0618 123.893 99.232 134.674 106.412 144.173C106.783 144.663 107.363 144.944 107.977 144.944C116.665 144.944 129.552 144.944 138.023 144.944",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.892 74.4681H130.238",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.765 74.4681L226.955 74.4681",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.2957,
    y: 98.3742,
    width: 15.7568,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.2957,
    y: 98.3742,
    width: 12.9483,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.1742,
    cy: 106.253,
    rx: 3.03412,
    ry: 5.80931,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.879 74.3582C242.746 73.7942 242.676 73.206 242.676 72.6014C242.676 68.3812 246.097 64.96 250.317 64.96C254.538 64.96 257.959 68.3812 257.959 72.6014C257.959 73.2223 257.885 73.8259 257.745 74.4038",
    stroke: "#021317"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.317,
    cy: 72.9623,
    r: 1.14442,
    stroke: "#021317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 65.4113V72.2417",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.128 147.046C229.262 143.309 225.316 128.687 223.845 114.218M268.19 147.046C289.549 147.046 316.777 147.046 334.922 147.046C337.132 147.046 338.916 145.255 338.916 143.046V30.0458C338.916 27.8367 337.126 26.0458 334.916 26.0458L251.913 26.0458C251.257 26.0458 250.642 26.3669 250.274 26.9104C250.148 27.0977 250.018 27.29 249.887 27.4872M248.717 29.2739C241.357 40.7073 228.554 64.0814 224.521 84.2821M224.169 86.166C224.096 86.5829 224.028 86.9981 223.963 87.4117C223.516 90.2924 223.23 94.0807 223.161 98.3594",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.518,
    y: 23.0651,
    width: 74.1986,
    height: 2.98072,
    rx: 1.49036,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.511 29.2706H248.236C247.745 29.2706 247.347 28.8729 247.347 28.3824V28.3824C247.347 27.892 247.745 27.4943 248.236 27.4943H309.511C311.516 27.4943 312.803 29.6255 311.869 31.3997L283.831 84.6654C283.37 85.5407 282.462 86.0887 281.473 86.0887H224.033C223.543 86.0887 223.145 85.6911 223.145 85.2006V85.2006C223.145 84.7101 223.543 84.3124 224.033 84.3124H281.473C281.803 84.3124 282.105 84.1298 282.259 83.838L310.297 30.5724C310.608 29.981 310.179 29.2706 309.511 29.2706Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.495 84.3969L230.082 80.1366C230.444 79.5393 231.093 79.1745 231.791 79.1745H284.655",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.571 79.1745L238.085 75.3813C238.455 74.8222 239.081 74.486 239.752 74.486H287.096",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.481,
    y: 98.3742,
    width: 15.7568,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.481,
    y: 98.3742,
    width: 12.9483,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.359,
    cy: 106.253,
    rx: 3.03412,
    ry: 5.80931,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.343,
    y: 104.259,
    width: 12.3125,
    height: 3.98758,
    rx: 1.99379,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.761 120.047C250.312 116.495 247.435 131.01 247.741 137.082C250.328 133.901 254.752 134.006 259.902 139.047C265.429 144.456 273.068 147.093 281.206 147.093C268.879 138.707 272.469 123.369 261.761 120.047Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.725 137.173H233.429C234.329 133.24 235.133 124.487 242.027 119.478C246.97 119.478 254.504 119.478 257.653 119.478",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.671 144.77C257.335 144.608 256.979 144.52 256.609 144.52C254.591 144.52 252.956 147.127 252.956 150.343C252.956 153.559 254.591 156.166 256.609 156.166C258.627 156.166 260.263 153.559 260.263 150.343C260.263 149.82 260.142 148.934 260.06 148.452",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.877 141.545C264.156 143.859 264.995 147.101 264.995 150.343C264.995 157.724 261.01 163.708 256.095 163.708C251.18 163.708 247.195 157.724 247.195 150.343C247.195 142.962 251.18 136.979 256.095 136.979C256.634 136.979 257.162 137.051 257.674 137.188",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.523 137.253C245.322 140.431 243.961 144.826 243.961 149.681C243.961 159.38 249.394 167.242 256.095 167.242C262.797 167.242 268.229 159.38 268.229 149.681C268.229 147.905 268.047 146.191 267.708 144.575",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.766 166.573C251.679 167.035 250.68 167.242 249.49 167.242C242.788 167.242 237.356 159.38 237.356 149.682C237.356 144.692 238.794 140.189 241.102 136.992",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.135 139.198L255.099 149.96C254.663 150.89 255.023 151.999 255.922 152.497V152.497C256.911 153.044 258.157 152.64 258.637 151.617L263.254 141.767",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.292 98.4253C287.712 93.4813 288.505 89.3908 289.217 86.6806C291.213 79.0763 308.23 43.5574 315.89 28.8774C316.233 28.2196 316.909 27.8199 317.651 27.8199H335.139C336.244 27.8199 337.139 28.7154 337.139 29.8199V142.944C337.139 144.049 336.248 144.944 335.143 144.944C327.617 144.944 310.847 144.944 300.458 144.944C299.844 144.944 299.264 144.663 298.893 144.173C291.713 134.674 288.543 123.893 287.458 114.059",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.777,
    y: 98.3742,
    width: 15.7568,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.777,
    y: 98.3742,
    width: 12.9483,
    height: 15.7568,
    rx: 3,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.655,
    cy: 106.253,
    rx: 3.03412,
    ry: 5.80931,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9393 22.7564V22.7564C89.9393 12.9498 97.8891 5 107.696 5L195.347 5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.597 22.7564V22.7564C167.597 12.9498 175.546 5 185.353 5L285.751 5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.597 22.7564V22.7564C269.597 12.9498 277.546 5 287.353 5H359.365",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3558_21202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 172,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleets);
export default __webpack_public_path__ + "static/media/fleets.a94eb4110345e0c389d682406d5d7d0a.svg";
export { ForwardRef as ReactComponent };